import React, { useState, useRef, useEffect } from 'react';

export default function SearchableSelect({ value, options, placeholder, onChange, onAddNew }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);
  const selected = options.find(o => o.value === value);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const filtered = search.trim()
    ? options.filter(o => o.label.toLowerCase().includes(search.toLowerCase()))
    : options;

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div
        className="inp inp-sel"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', paddingRight: 36 }}
        onClick={() => { setOpen(!open); setSearch(''); }}
      >
        <span style={{ color: selected ? 'var(--t)' : 'var(--c3)', fontSize: selected ? 14 : 14 }}>
          {selected ? selected.label : placeholder || 'Selecionar...'}
        </span>
      </div>
      {open && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 50,
          background: '#fff', border: '1px solid var(--c2)', borderRadius: 10,
          boxShadow: '0 8px 24px rgba(0,0,0,.1)', maxHeight: 240, overflow: 'hidden',
          marginTop: 4,
        }}>
          {options.length > 8 && (
            <div style={{ padding: '6px 10px', borderBottom: '1px solid var(--c1)' }}>
              <input
                className="inp"
                placeholder="Buscar..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                onClick={e => e.stopPropagation()}
                autoFocus
                style={{ fontSize: 13, padding: '6px 10px' }}
              />
            </div>
          )}
          <div style={{ overflowY: 'auto', maxHeight: 200 }}>
            <div
              style={{ padding: '10px 14px', cursor: 'pointer', color: 'var(--c4)', borderBottom: '1px solid var(--c1)', fontSize: 13 }}
              onClick={() => { onChange(''); setOpen(false); }}
            >
              {placeholder || 'Nenhum'}
            </div>
            {filtered.map(o => (
              <div
                key={o.value}
                style={{
                  padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid var(--c1)',
                  background: value === o.value ? 'var(--g3)' : 'transparent',
                  fontWeight: value === o.value ? 700 : 400, fontSize: 13,
                }}
                onClick={() => { onChange(o.value); setOpen(false); }}
              >
                {o.label}
                {o.sub && <span style={{ color: 'var(--c3)', fontSize: 11, marginLeft: 8 }}>{o.sub}</span>}
              </div>
            ))}
            {onAddNew && (
              <div
                style={{ padding: '10px 14px', cursor: 'pointer', borderTop: '1px solid var(--c1)', color: 'var(--g)', fontWeight: 600, fontSize: 13 }}
                onClick={() => { setOpen(false); onAddNew(); }}
              >
                + Novo cliente
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
